// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class LeaveBalance  {
    _originalTypeClassName = "Loom.BO.LeaveBalance";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
LeaveBalance.translate = translateService;
}
this.Id = null;
this.Year = null;
this.LeaveQuota = null;
this.UsedDays = null;
this.RemainingDays = null;
this.PercentageConsumed = null;
this.Caption = null;
this.CurrentYearQuota = null;
this.CarryoverQuota = null;
this.HasBeenCarriedOver = false;
this.CarriedOverDaysToNextYear = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Year:any;
LeaveQuota:any;
UsedDays:any;
RemainingDays:any;
PercentageConsumed:any;
Caption:any;
CurrentYearQuota:any;
CarryoverQuota:any;
HasBeenCarriedOver:any;
CarriedOverDaysToNextYear:any;
Policy:any;
Employee:any;
static setPolicy = ($this, value) => {
var oldValue = $this.Policy;
$this.Policy = value;
if (value != null) {
}
}
static setEmployee = ($this, value) => {
var oldValue = $this.Employee;
$this.Employee = value;
if (value != null) {
if (oldValue != null) {
Domain.Employee.removeLeaveBalances(oldValue, $this);
}
Domain.Employee.addLeaveBalances(value, $this);
}
}

static GetCaption($this: any): any{return $this?.Policy?.Caption + " - " + Joove.Common.safeNumber($this?.Year) + " - " + $this?.Policy?.Country?.ISOCode2;
}
static GetLeaveQuota($this: any): any{return ($this?.Policy?.HasUnlimitedQuota ? 0 : Joove.Common.safeNumber($this?.CurrentYearQuota) + Joove.Common.safeNumber($this?.CarryoverQuota));
}
static GetPercentageConsumed($this: any): any{if (($this?.Policy?.HasUnlimitedQuota)) {return 1;}
if ((CLMS.Framework.Number.GreaterThan(() => $this.LeaveQuota, () => 0))) {return Joove.Common.mathRound(Joove.Common.safeNumber($this?.UsedDays) / Joove.Common.safeNumber((parseFloat(($this?.LeaveQuota) as any))), 2);}
return 0;
}
static GetRemainingDays($this: any): any{return ($this?.Policy?.HasUnlimitedQuota ? 0 : Joove.Common.safeNumber($this?.LeaveQuota) - Joove.Common.safeNumber($this?.UsedDays) - Joove.Common.safeNumber($this?.CarriedOverDaysToNextYear));
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}